const animeConfig = {
    username: "WangYiDev", // Replace with your actual AniList username
    defaultType: "ANIME", // ANIME or MANGA
};

export default animeConfig;
